import consts from 'services/metaData/consts';

const columns = [
    {
        key: 'appInfo',
        title: 'Name',
        isComponent: true,
        style: { color: consts.COLORS.DARK_300 },
        width: '33%'
    },
    {
        key: 'mediationAdUnits',
        title: 'Active ad units ',
        style: { color: consts.COLORS.DARK_300 },
        width: '57%',
        isComponent: true
    },
    {
        key: 'archived',
        title: '',
        isComponent: true
    }

];

const currencyMap = {
    USD: '$'
};

const kpiPropertyToText = {
    today: 'Today',
    yesterday: 'Yesterday',
    lastSevenDays: 'Last 7 Days',
    thisMonth: 'This Month'
};

export default Object.freeze({
    columns,
    currencyMap,
    kpiPropertyToText
});
